import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetBatchJob_batchJob as BatchJobGenerated,
  GetBatchJob_batchJob_errors as GetBatchJobErrorsGenerated,
  GetBatchJob as GetBatchJobGenerated,
  GetBatchJobVariables as GetBatchJobsVariablesGenerated,
} from "core/queries/__generated__/GetBatchJob";

// Queries
export interface BatchJob extends BatchJobGenerated {}
export interface GetBatchJobResponse extends GetBatchJobGenerated {}
export interface GetBatchJobVariables extends GetBatchJobsVariablesGenerated {}
export interface GetBatchJobErrors extends GetBatchJobErrorsGenerated {}

export const getBatchJob = gql`
  query GetBatchJob($id: ID!) {
    batchJob(id: $id) {
      id
      errors {
        task {
          id
          name
        }
      }
      total
      remaining
      status
    }
  }
`;

export interface UseGetBatchJobQueryOptions {
  pollInterval?: number;
  variables: GetBatchJobVariables;
}
export const useGetBatchJobQuery = ({
  pollInterval,
  variables,
}: UseGetBatchJobQueryOptions) =>
  useQuery<GetBatchJobResponse, GetBatchJobVariables>(getBatchJob, {
    fetchPolicy: "cache-and-network",
    pollInterval,
    variables,
  });
